
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Icon","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M7.59 7.59v984.82h984.82V7.59zm872.82 872.82H119.59V119.59h760.82z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M233 474.4h231.9c27.85 0 44.54-30.94 29.26-54.22l-118-179.62a35 35 0 00-58.82.46L203.48 420.64C188.7 444 205.44 474.4 233 474.4zM623.76 458.61a35 35 0 0058.82-.47l113.94-179.62c14.78-23.31-2-53.75-29.56-53.75h-231.9c-27.85 0-44.54 30.94-29.26 54.21zM197.98 574.38H500v79.66H197.98zM197.98 729.61h604.04v79.66H197.98z"}})])
          )
        }
      }
    